export { default as parseDuration } from './parseDuration';
